import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import map from 'ramda/src/map'
import { GET_CREATORS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { VIEW_CREATOR_DATA_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { searchCreatorsKey } from 'root/src/shared/constants/keys'

export default async (input) => {
	const payload = {
		value: input,
		section: searchCreatorsKey,
	}

	const { body } = await invokeApiRequest(GET_CREATORS, payload, {}, true)

	return map(({ image, displayName, mnemonicId }) => (
		{
			label: displayName,
			image,
			id: displayName,
			value: displayName,
			redirect: {
				routeId: VIEW_CREATOR_DATA_ROUTE_ID,
				routeParams: { recordId: mnemonicId },
			},
		}
	), body)
}
